// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"223":"home-page","940":"portfolio-page"}[chunkId] + "." + {"223":"4632f4a1","940":"e10e25bd"}[chunkId] + ".chunk.css";
};